import React, { useContext, useEffect, useState } from "react";
import Images from "../../Helpers/Images";
import Select from "react-select";
import { BsCamera, BsFillPencilFill } from "react-icons/bs";
import { RiRefreshLine, RiCloseLargeLine } from "react-icons/ri";
import { Button, Col, Form, Modal, Row, Tab } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-country-state-city/dist/react-country-state-city.css";
import GenderOptions from "../../Helpers/GenderOptions.json";
import { APIRequest, ApiUrl, authHeaders } from "../../Helpers/ApiHelper";
import moment from "moment";
import {
  Loader,
  Message,
  Notification,
  Placeholder,
  Uploader,
  useToaster,
} from "rsuite";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { Auth } from "../../Contexts/AuthContext";
import secureHash from "../../Helpers/secureHash";
import Header from "../../Components/comman/Header";
import MobileHeader from "../../Components/comman/MobileHeader";
import Sidebar from "./Sidebar";
import CustomLoader from "../../Components/comman/Loader/CustomLoader";
import customCountries from "../../Helpers/countries.json";
import customStates from "../../Helpers/states.json";
import customCities from "../../Helpers/cities.json";
import PhylloSDK from "../../phylloSDKService/phylloSDKInit";

const Account = () => {
  const toaster = useToaster();
  const [show, setShow] = useState(false);
  const [disConnectShow, setDisConnectShow] = useState(false);
  const { auth, setAuth, setFavoriteCounts, DeleteAccount } = useContext(Auth);
  const [uploading, setUploading] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);
  const [profileData, setProfileData] = useState({});
  const [workPlatformsData, setWorkPlatformsData] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const [locations, setLocations] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [categoriesNiches, setCategoriesNiches] = useState({});
  const [s, ss] = useState("State");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [phylloConnectedAccounts, setPhylloConnectedAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const phylloSDK = new PhylloSDK();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePhylloConnect = async (item) => {
    await phylloSDK.connectPhyllo(item);
  };
  // const handleInstagramConnect = async () => {
  //   await phylloSDK.connectInstagram();
  // };
  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    setSelectedState(null);
    setSelectedCity(null);
    setFilteredCities([]);
    if (value) {
      const states =
        customStates.find((item) => item.id === value.id)?.states || [];
      setFilteredStates(states);
    } else {
      setFilteredStates([]);
    }
  };
  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedCity(null);
    if (value) {
      const stateData = customCities.find((item) =>
        item.states?.some((state) => state.id === value.id)
      );
      const cities =
        stateData?.states?.find((state) => state.id === value.id)?.cities || [];
      setFilteredCities(cities);
    } else {
      setFilteredCities([]);
    }
  };
  const fileUploadParams = {
    folder: auth?.userRole.toLowerCase(),
  };
  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };
  const handleDeleteSubmit = () => {
    let config = {
      url: ApiUrl.accountDelete,
      method: "POST",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        setShow(false);
        DeleteAccount();
        console.log(res);
      },
      (err) => {
        console.log(err);
        DeleteAccount();
      }
    );
  };
  const handleClose = () => {
    setShow(false);
  };
  const handledisconnectClose = () => {
    setDisConnectShow(false);
    setSelectedAccountId(null);
  };

  const handledisconnectShow = () => setDisConnectShow(true);
  const handleShow = () => setShow(true);
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#f4f4f8",
      fontWeight: "bold",
      color: "#333",
      fontFamily: "Poppins, sans-serif",
    }),
    option: (provided, state) => ({
      ...provided,
      fontFamily: "Poppins, sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      backgroundColor: state.isSelected ? "#afd7d1" : "#f4f4f8",
      color: state.isSelected ? "#000000" : "#575757",
      borderBottom: "1px solid #ccc",
      "&:last-child": {
        borderBottom: "none",
      },
    }),
    singleValue: (provided) => ({
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "Poppins, sans-serif",
      color: "#333",
      ...provided,
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: "Poppins, sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      // fontWeight: "bold",
      color: "#575757",
    }),
    input: (provided) => ({
      ...provided,
      fontFamily: "Poppins, sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      // fontWeight: "bold",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#afd7d1" : "#dee2e6",
      boxShadow: state.isFocused ? "none" : "none",
      fontFamily: "Poppins, sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      "&:hover": {
        borderColor: state.isFocused
          ? "#afd7d1"
          : provided["&:hover"].borderColor,
      },
    }),
  };
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  const parseId = (id) => {
    if (!id) return null;
    const parsed = parseInt(id);
    return isNaN(parsed) ? null : parsed;
  };
  const handleOnChange = (name, value) => {
    if (name === "dob") {
      value = value !== undefined ? formatDate(value) : "";
    }
    let updatedValue = value;
    if (name === "country_id" || name === "state_id" || name === "city_id") {
      if (value) {
        updatedValue = {
          id: parseInt(value.id || value.value),
          name: value.name || value.label,
        };
      } else {
        updatedValue = null;
      }
    }
    const updatedData = { ...profileData };

    if (name === "country_id") {
      updatedData.country_id = updatedValue?.id || null;
      updatedData.country = updatedValue?.name || null;
      if (!value) {
        updatedData.state_id = null;
        updatedData.state = null;
        updatedData.city_id = null;
        updatedData.city = null;
      }
    } else if (name === "state_id") {
      updatedData.state_id = updatedValue?.id?.toString() || null;
      updatedData.state = updatedValue?.name || null;
      if (!value) {
        updatedData.city_id = null;
        updatedData.city = null;
      }
    } else if (name === "city_id") {
      updatedData.city_id = updatedValue?.id?.toString() || null;
      updatedData.city = updatedValue?.name || null;
    } else {
      updatedData[name] = updatedValue;
    }
    setProfileData(updatedData);
    console.log("Updated profileData:", updatedData);
  };
  const updateProfileData = () => {
    const updatedformData = {
      ...profileData,
      country: selectedCountry?.name || profileData?.country || null,
      country_id: profileData.country_id
        ? parseInt(profileData.country_id)
        : null,
      state: selectedState?.name || profileData?.state || null,
      state_id: profileData.state_id ? profileData.state_id.toString() : null,
      city: selectedCity?.name || profileData?.city || null,
      city_id: profileData.city_id ? profileData.city_id.toString() : null,
    };

    let config = {
      url: ApiUrl.updateInfluncerProfile,
      method: "POST",
      body: {
        ...updatedformData,
        secureHash: secureHash.generate(updatedformData),
      },
    };
    console.log("what sending", config.body);
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        console.log("res", res);
        setIsLoading(false);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("favCounts", res?.total_favorite_counts);
        setFavoriteCounts(res?.total_favorite_counts);
        setAuth({
          ...auth,
          user: res.user,
        });
        toaster.push(
          <Notification type="success" header="Success">
            <Placeholder.Paragraph
              style={{ width: 100, color: "red" }}
              rows={0}
            />
            Profile updated successfully
          </Notification>,
          {
            placement: "topEnd",
          }
        );
      },
      (err) => {
        if (err?.response?.status === 422) {
          setValidationErrors(err?.response?.data?.errors);
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        }
        setIsLoading(false);
      }
    );
  };
  const handleUpdateProfile = () => {
    updateProfileData();
  };
  useEffect(() => {
    if (profileData?.country_id) {
      const country = customCountries.find(
        (c) => c.id === profileData.country_id
      );
      if (country) {
        setSelectedCountry({
          value: country.id,
          label: country.name,
          ...country,
        });
        const states =
          customStates.find((item) => item.id === country.id)?.states || [];
        setFilteredStates(states);
      }
    }

    if (profileData?.state_id) {
      const state = filteredStates.find((s) => s.id === profileData.state_id);
      if (state) {
        setSelectedState({
          value: state.id,
          label: state.name,
          ...state,
        });
        const stateData = customCities.find((item) =>
          item.states?.some((st) => st.id === state.id)
        );
        const cities =
          stateData?.states?.find((st) => st.id === state.id)?.cities || [];
        setFilteredCities(cities);
      }
    }

    if (profileData?.city_id) {
      const city = filteredCities.find((c) => c.id === profileData.city_id);
      if (city) {
        setSelectedCity({
          value: city.id,
          label: city.name,
          ...city,
        });
      }
    }
  }, [profileData, filteredStates, filteredCities]);
  useEffect(() => {
    getProfileData();
    fetchProfiles();
    getAllWorkPlatforms();
  }, []);
  const getProfileData = () => {
    let config = {
      url: ApiUrl.getInfluncerProfile,
      method: "GET",
      body: {},
    };
    APIRequest(
      config,
      (res) => {
        const data = res?.data;
        setProfileData(data);
        setLocations(res?.locations);
        if (data) {
          if (data.country_id) {
            const countryId = parseId(data.country_id);
            const country = customCountries.find((c) => c.id === countryId);
            if (country) {
              setSelectedCountry({
                value: country.id,
                label: country.name,
                ...country,
              });
              const states =
                customStates.find((item) => item.id === countryId)?.states ||
                [];
              setFilteredStates(states);
              if (data.state_id) {
                const stateId = parseId(data.state_id);
                const state = states.find((s) => s.id === stateId);

                if (state) {
                  setSelectedState({
                    value: state.id,
                    label: state.name,
                    ...state,
                  });
                  const stateData = customCities.find((item) =>
                    item.states?.some((st) => st.id === stateId)
                  );

                  if (stateData) {
                    const cities =
                      stateData.states?.find((st) => st.id === stateId)
                        ?.cities || [];
                    setFilteredCities(cities);
                    if (data.city_id) {
                      const cityId = parseId(data.city_id);
                      const city = cities.find((c) => c.id === cityId);

                      if (city) {
                        setSelectedCity({
                          value: city.id,
                          label: city.name,
                          ...city,
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }

        setIsLoading(false);
        ss(data?.found_us_via);
      },
      (err) => {
        setIsLoading(false);
      }
    );
  };
  const getAllWorkPlatforms = () => {
    let config = {
      url: ApiUrl.getWorkPlatforms,
      method: "GET",
      body: {},
    };
    APIRequest(
      config,
      (res) => {
        const data = res?.data;
        setWorkPlatformsData(data);
        setIsLoading(false);
      },
      (err) => {
        setIsLoading(false);
        console.log("error", err);
      }
    );
  };
  const fetchProfiles = () => {
    let config = {
      url: ApiUrl.getPhylloSocialAccounts,
      method: "GET",
      body: {},
    };
    APIRequest(
      config,
      (res) => {
        const data = res?.data;
        setPhylloConnectedAccounts(data);
      },
      (err) => {
        console.log("error", err);
      }
    );
  };
  const disConnectAnAccount = (accountId) => {
    console.log("accountId", accountId);
    let config = {
      url: ApiUrl.disConnectPhylloAccount,
      method: "POST",
      body: {
        account_id: accountId,
      },
    };
    APIRequest(
      config,
      (res) => {
        console.log("response", res);
        fetchProfiles();
        setDisConnectShow(false);
        toaster.push(
          <Notification type="success" header="Success">
            {res?.message || "Account Removed Successfully"}
          </Notification>,
          {
            placement: "topEnd",
          }
        );
        setSelectedAccountId(null);
      },
      (err) => {
        console.log("error", err);

        setDisConnectShow(false);
        toaster.push(
          <Notification type="error" header="Error">
            <Placeholder.Paragraph
              style={{ width: 100, color: "red" }}
              rows={0}
            />{" "}
            {err?.message ||
              "something went wrong.please try again after some time."}
          </Notification>,
          {
            placement: "topEnd",
          }
        );
        setSelectedAccountId(null);
      }
    );
  };
  // console.log("phylloConnectedAccounts", phylloConnectedAccounts);
  const checkWorkPlaceIsConnected = (type) => {
    const isconnected = phylloConnectedAccounts.find(
      (item) => item?.profile?.platform == type
    );
    if (isconnected) return true;
    else return false;
  };

  return (
    <div className="main-pages-wrapper">
      <Header />
      <MobileHeader />
      <div className="account-main-wrapper">
        <Tab.Container activeKey={`account`}>
          <Sidebar />
          <CustomLoader visible={isLoading} />
          <div className="myAccount-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"account"}>
                <div className="myAccount-inner">
                  <h6 className="heading-title">Personal Information</h6>
                  <div className="account-info-wrapper box">
                    <div className="account-profile-img-box">
                      <Uploader
                        fileListVisible={false}
                        listType="picture"
                        headers={authHeaders}
                        data={fileUploadParams}
                        action={ApiUrl.uploadLogo}
                        onUpload={(file) => {
                          setUploading(true);
                          previewFile(file.blobFile, (value) => {
                            setFileInfo(value);
                          });
                        }}
                        onSuccess={(response, file) => {
                          setUploading(false);
                          setProfileData({
                            ...profileData,
                            avatar_file: response?.file,
                          });
                          // toaster.push(
                          //   <Message type="success" header="Success">
                          //     Uploaded successfully
                          //   </Message>
                          // );
                        }}
                        onError={() => {
                          setFileInfo(null);
                          setUploading(false);
                          toaster.push(
                            <Message type="error" header="Error">
                              Upload failed
                            </Message>
                          );
                        }}
                      >
                        <button
                          style={{ width: 120, height: 120, marginTop: 0 }}
                        >
                          {uploading && <Loader backdrop center />}
                          {fileInfo ? (
                            <img
                              alt="fileInfo"
                              src={fileInfo}
                              width="100%"
                              height="100%"
                            />
                          ) : (
                            <img
                              alt="fileInfsso"
                              src={
                                profileData?.avatar
                                  ? profileData?.avatar
                                  : Images.defUser
                              }
                              width="100%"
                              height="100%"
                            />
                          )}
                          <div className="upload">
                            <BsCamera />
                          </div>
                        </button>
                      </Uploader>
                    </div>
                    {/* personal info */}
                    <div className="personal-info-form ">
                      <Form>
                        <Row className="mb-3">
                          {/* first name */}
                          <Form.Group
                            as={Col}
                            md="6"
                            className="position-relative"
                          >
                            <Form.Label>First name</Form.Label>
                            <Form.Control
                              type="text"
                              name="first_name"
                              value={profileData?.first_name}
                              onChange={(e) => {
                                handleOnChange("first_name", e.target.value);
                              }}
                            />
                            <Form.Control.Feedback tooltip>
                              Looks good!
                            </Form.Control.Feedback>
                          </Form.Group>
                          {/* last name */}
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationFormik102"
                            className="mobile-case"
                          >
                            <Form.Label>Last name</Form.Label>
                            <Form.Control
                              type="text"
                              name="last_name"
                              value={profileData?.last_name}
                              onChange={(e) => {
                                handleOnChange("last_name", e.target.value);
                              }}
                            />

                            <Form.Control.Feedback tooltip>
                              Looks good!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Row>

                        <Row className="mb-3">
                          {/* email */}
                          <Form.Group as={Col} md="6" className="mb-3">
                            <Form.Label>Email </Form.Label>
                            <Form.Control
                              type="email"
                              value={profileData?.email}
                              onChange={(e) => {
                                handleOnChange("email", e.target.value);
                              }}
                            />
                          </Form.Group>
                          {/* phone number */}
                          <Form.Group
                            as={Col}
                            md="6"
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>Phone No.</Form.Label>
                            <PhoneInput
                              name="phone"
                              country={"in"}
                              value={profileData?.phone}
                              onChange={(value) => {
                                handleOnChange("phone", value);
                              }}
                            />
                          </Form.Group>
                        </Row>
                        {/* <Row>
                          <Form.Group as={Col} md="12" className="mb-3">
                            <Button className="change-password">
                              <BsFillPencilFill />
                              Change Password
                            </Button>
                          </Form.Group>
                        </Row> */}
                      </Form>
                    </div>
                  </div>
                  {/* shipping address */}
                  <h6 className="heading-title">Shipping Address</h6>
                  <div className="Shipping-address-wrapper box">
                    <Form>
                      <Row className="mb-3">
                        {/* street */}
                        <Form.Group
                          as={Col}
                          md="6"
                          className="position-relative"
                        >
                          <Form.Label>Street</Form.Label>
                          <Form.Control
                            type="text"
                            name="street"
                            value={profileData?.street}
                            onChange={(e) => {
                              handleOnChange("street", e.target.value);
                            }}
                          />
                          <Form.Control.Feedback tooltip>
                            Looks good!
                          </Form.Control.Feedback>
                        </Form.Group>
                        {/* aprtment */}
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationFormik102"
                          className="mobile-case"
                        >
                          <Form.Label>Apt / Suite / Unit</Form.Label>
                          <Form.Control
                            type="text"
                            name="unit"
                            value={profileData?.unit}
                            onChange={(e) => {
                              handleOnChange("unit", e.target.value);
                            }}
                          />

                          <Form.Control.Feedback tooltip>
                            Looks good!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      {/* country */}
                      <Row className="mb-3">
                        <Form.Group
                          as={Col}
                          md="6"
                          className="position-relative"
                        >
                          <Form.Label>Country</Form.Label>
                          <div className="custom-drop">
                            <Select
                              placeholder="Select Country"
                              styles={customStyles}
                              isClearable={true}
                              value={selectedCountry}
                              onChange={(value) => {
                                setSelectedCountry(value);
                                handleCountryChange(value);
                                handleOnChange("country_id", value);
                              }}
                              options={customCountries.map((country) => ({
                                value: country.id,
                                label: country.name,
                                ...country,
                              }))}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationFormik102"
                          className="mobile-case"
                        >
                          <Form.Label>State</Form.Label>

                          <Select
                            placeholder="Select State"
                            styles={customStyles}
                            isClearable={true}
                            value={selectedState}
                            onChange={(value) => {
                              setSelectedState(value);
                              handleStateChange(value);
                              handleOnChange("state_id", value);
                            }}
                            options={filteredStates.map((state) => ({
                              value: state.id,
                              label: state.name,
                              ...state,
                            }))}
                            isDisabled={!selectedCountry}
                          />
                        </Form.Group>
                      </Row>
                      {/* city */}
                      <Row className="mb-3">
                        <Form.Group
                          as={Col}
                          md="6"
                          className="position-relative"
                        >
                          <Form.Label>City</Form.Label>
                          <Select
                            placeholder="Select City"
                            styles={customStyles}
                            isClearable={true}
                            value={selectedCity}
                            onChange={(value) => {
                              setSelectedCity(value);
                              handleOnChange("city_id", value);
                            }}
                            options={filteredCities.map((city) => ({
                              value: city.id,
                              label: city.name,
                              ...city,
                            }))}
                            isDisabled={!selectedState}
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="6" className="mobile-case">
                          <Form.Label>Postcode</Form.Label>
                          <Form.Control
                            type="text"
                            name="pincode"
                            value={profileData?.pincode}
                            onChange={(e) => {
                              handleOnChange("pincode", e.target.value);
                            }}
                          />
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                  {/* misc details */}
                  <h6 className="heading-title">Miscellaneous Info</h6>
                  <div className="miscellaneous-container box">
                    <Form>
                      {/* dob */}
                      <Row className="mb-3">
                        <Form.Group
                          as={Col}
                          md="6"
                          className="position-relative"
                        >
                          <Form.Label>DOB</Form.Label>
                          <ReactDatePicker
                            selected={profileData?.dob}
                            // onChange={(date) => setStartDate(date)}
                            onChange={(value) => {
                              handleOnChange("dob", value);
                            }}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            value={
                              profileData?.dob ? new Date(profileData?.dob) : ""
                            }
                            color="red"
                            dropdownMode="select"
                          />
                          <Form.Control.Feedback tooltip>
                            Looks good!
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" className="mobile-case">
                          <Form.Label>Gender</Form.Label>
                          <Select
                            options={GenderOptions}
                            defaultInputValue=""
                            styles={customStyles}
                            value={{
                              label: profileData?.gender,
                              value: profileData?.gender,
                            }}
                            onChange={(item) => {
                              handleOnChange("gender", item.value);
                            }}
                          />
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                  <div className="update-box">
                    <Button className="theme-btn" onClick={handleUpdateProfile}>
                      Update
                    </Button>
                  </div>
                  {/* social contents */}
                  <h6 className="heading-title">Social Accounts</h6>
                  <div className="socialMediaWrapper">
                    <div className="grid">
                      {console.log("+++>>>", phylloConnectedAccounts)}
                      {phylloConnectedAccounts.map((account) => {
                        const updatedDate = moment(account?.updated_at);
                        const currentDate = moment();
                        const isSameDay = updatedDate.isSame(
                          currentDate,
                          "day"
                        );
                        const hasEngagementRate = account?.engagement_rate > 0;
                        const showProcessingMessage =
                          isSameDay && !hasEngagementRate;

                        return (
                          <div
                            key={account?.id}
                            className="card"
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform =
                                "translateY(-4px)";
                              e.currentTarget.style.boxShadow =
                                "0 8px 24px rgba(0, 0, 0, 0.12)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow =
                                "0 4px 12px rgba(0, 0, 0, 0.08)";
                            }}
                          >
                            <div className="card-inner">
                              {/* Header */}
                              <div className="header">
                                <div className="accountInfoWrapper">
                                  <div className="account-info">
                                    <h3 className="username">
                                      @{account?.profile?.raw_payload?.username}
                                    </h3>
                                    <span className="status">
                                      {account.status}
                                    </span>
                                  </div>
                                </div>
                                <img
                                  src={
                                    account?.profile?.raw_payload?.work_platform
                                      ?.logo_url
                                  }
                                  className="platformImg"
                                />
                              </div>
                              {/* Stats */}
                              <div className="stats">
                                <div className="stat-item">
                                  <div className="stat-label">
                                    {account?.profile?.platform === "YouTube"
                                      ? "Subscribers"
                                      : "Followers"}
                                  </div>
                                  <div className="stat-value">
                                    {account?.profile?.platform === "YouTube"
                                      ? account?.profile?.raw_payload?.reputation?.subscriber_count?.toLocaleString()
                                      : account?.profile?.raw_payload?.reputation?.follower_count.toLocaleString()}
                                  </div>
                                </div>
                                <div className="stat-item">
                                  <div className="stat-label">
                                    Engagement Rate
                                  </div>
                                  <div
                                    className={`stat-value ${
                                      account.engagement_rate === 0
                                        ? "low-engagement"
                                        : ""
                                    }`}
                                  >
                                    {account?.engagement_rate}%
                                  </div>
                                </div>
                              </div>
                              {/* Divider */}
                              <div className="divider" />
                              {/* Last Updated */}
                              <div className="lastUpdated">
                                <div className="last-updated-label">
                                  Last Updated
                                </div>
                                <div className="last-updated-date">
                                  {updatedDate.format("LL")}
                                </div>
                              </div>
                              <div className="divider" />
                              {showProcessingMessage ? (
                                <div className="processing-message">
                                  <p className="processing-text">
                                    ⏳ Data collection in progress. It may take
                                    24-48 hours to gather complete statistics.
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <div
                                    className={`notice ${
                                      hasEngagementRate ? "active-notice" : ""
                                    }`}
                                  >
                                    <p className="notice-text">
                                      {!hasEngagementRate
                                        ? "It looks like you have no recent activity on this account, resulting in zero engagement."
                                        : "✓ Active account with recent engagement."}
                                    </p>
                                  </div>
                                </>
                              )}
                            </div>
                            {!showProcessingMessage && (
                              <div className="actionsBtnWrapper">
                                <a
                                  className="actions"
                                  onClick={() => {
                                    handlePhylloConnect(
                                      account?.profile?.raw_payload
                                        ?.work_platform
                                    );
                                  }}
                                >
                                  <RiRefreshLine /> Manage
                                </a>
                                {/* <a
                                  className="actions disconnected"
                                  onClick={() => {
                                    setSelectedAccountId(account?.id);
                                    setDisConnectShow(true);
                                  }}
                                >
                                  <RiCloseLargeLine /> Disconnect
                                </a> */}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="social-account-wrapper  box">
                    {phylloConnectedAccounts.length <= 0 && (
                      <div className="no-account">
                        <p>
                          <strong>Note : </strong> We only support one profile
                          connection per social platform. As sessions expire
                          after 3 months for security reasons, please be sure to
                          reconnect as needed to avoid interruption to your
                          campaigns. Follower count updates daily, engagement
                          rate updates monthly.
                        </p>
                        <img src={Images.noAccount} alt="no-account" />
                        <p className="no-account-text">
                          No social accounts connected.
                        </p>
                      </div>
                    )}
                    <div className="connect-box">
                      <h6>Connect</h6>
                      <p>
                        In order to access platform-specific collaborations,
                        please connect your social accounts. Your data is
                        secure. We only use your information to verify your
                        eligibility for campaigns and generating insights for
                        registered brands. For more information, please see our
                        <a href="/privacy-policy"> Privacy Policy</a> .
                      </p>
                      <div className="social-btns">
                        {console.log("workPlatformsData", workPlatformsData)}
                        {workPlatformsData?.map(
                          (workPlatform, workId) =>
                            !checkWorkPlaceIsConnected(workPlatform.name) && (
                              <>
                                {console.log("workPlatform++", workPlatform)}
                                <Button
                                  key={workId}
                                  onClick={() => {
                                    handlePhylloConnect(workPlatform);
                                  }}
                                >
                                  {workPlatform.name}
                                  <img src={workPlatform.logo_url} alt="logo" />
                                  {console.log("btn-Platforms", workPlatform)}
                                </Button>
                              </>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                  <h6 className="heading-title">Manage Account</h6>
                  <div className="manage-account box">
                    <Button onClick={handleShow}>Delete Account</Button>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
        {/* delete account */}
        <Modal
          show={show}
          onHide={handleClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="sign-out-modal"
        >
          <Modal.Body>
            <p className="sign-out-text">
              Are You Sure You Want To Delete Account ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} className="no-btn">
              No
            </Button>
            <Button className="yes-btn" onClick={handleDeleteSubmit}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        {/* disconnect account */}
        <Modal
          show={disConnectShow}
          onHide={handledisconnectClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="sign-out-modal"
        >
          <Modal.Body>
            <p className="sign-out-text">
              Are You Sure You Want To Disconnect Account ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handledisconnectClose} className="no-btn">
              No
            </Button>
            <Button
              className="yes-btn"
              onClick={() => {
                if (selectedAccountId) {
                  disConnectAnAccount(selectedAccountId);
                }
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Account;
